import { IContractState } from './ContractRedux';
import { ActionWithPayload } from './MovieRedux';
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist';

const initialState = {
    ref:null
}


export const actionTypes = {
  setRef: 'setRef',
}


export const reducer = persistReducer(
  { storage, key: 'v100-demo1-contract', whitelist: ['contracts'] },
    
  (state: any = initialState, action: ActionWithPayload<any>) => {
    switch (action.type) {
      case actionTypes.setRef: {
        const ref = action.payload?.ref
        return {...state, ref}
      }
      default:
        return state
    }
  }
)

export const actions = {
  setContracts: (ref: any) => ({
    type: actionTypes.setRef,
    payload: {ref},
  }),
}

